<template>
    <v-card :loading="loading" min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <slot>
            <v-card-title>
                <v-layout row wrap>
                    <v-col cols="6">
                        {{ title }}
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <v-btn
                            v-if="hasAddNewButton"
                            color="primary"
                            dark
                            class="ml-2"
                            @click="addNewItem"
                        >
                            Adaugare
                        </v-btn>
                    </v-col>
                    <v-col md="5" sm="12">
                        <period-selector v-model="period" :button-class="['mt-3']"></period-selector>
                    </v-col>
                    <v-col md="4" sm="12">
                        <v-autocomplete
                            v-model="filterByVehicle"
                            :items="vehicles"
                            item-value="id"
                            :item-text="(item) => {
                                return `${_.get(item, 'brand', '')} ${_.get(item, 'model', '')} - (${_.get(item, 'vehicle_plate', '?') || '?'})`
                            }"
                            placeholder="Selecteaza echipament/auto"
                            single-line
                            clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col md="3" sm="12" class="text-right">
                        <search-field v-model="search"></search-field>
                    </v-col>
                </v-layout>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar
                    flat
                >
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        dark
                        class="ml-2"
                        @click="createExport"
                    >
                        Export PDF
                    </v-btn>
                </v-toolbar>
            </template>
            <template v-slot:item.supplier_id="{ item }">
                {{ _.get(item.supplier, 'name', 'Nedefinit') }}
            </template>
            <template v-slot:item.document_date="{ item }">
                {{ new Date(item.document_date) | date }}
            </template>
            <template v-slot:item.vehicle_id="{ item }">
                <template v-if="item.object">
                    {{ _.get(item.object, 'brand', 'Marca necunoscuta') }}
                    {{ _.get(item.object, 'model', 'Model necunoscut') }}
                    ({{ _.get(item.object, 'vehicle_plate', 'Numar identificare necunoscut') || 'Numar identificare necunoscut' }})
                </template>
                <template v-else>
                    Necunoscut
                </template>
            </template>
            <template v-slot:item.amount_with_vat="{ item }">
                {{ item.amount_with_vat | price }}
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import SmartTable from "Components/SmartTable";
    import PeriodSelector from "Components/common/PeriodSelector";
    import ACL from "Mixins/acl";
    export default {
        mixins: [ACL],
        components: {
            PeriodSelector
        },
        extends: SmartTable,
        data: () => ({
            title: 'Raport flota vehicule',
            loading: false,
            dialog: false,
            headers: [
                { text: 'Furnizor', value: 'supplier_id' },
                { text: 'Data', value: 'document_date' },
                { text: 'Vehicul', value: 'vehicle_id' },
                { text: 'Valoare', value: 'amount_with_vat' },
            ],
            options: {
                sortBy: ['id'],
                sortDesc: [true]
            },
            items: [],
            editedIndex: -1,
            period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
            filterByVehicle: null,
            vehicles: []
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            period: {
                async handler(val) {
                    await this.initialize()
                }
            },
            filterByVehicle: {
                async handler(val) {
                    await this.initialize()
                }
            }
        },

        async created () {
            await this.initialize()
            await this.loadVehicles()
        },

        methods: {
            async loadVehicles() {
                this.vehicles = await this.$db.Equipment
                    .where('customer_id', this.Static.selfClientId)
                    .where('active', 1)
                    .limit(2000)
                    .get()
                    .then(({data}) => data)
            },
            async initialize () {
                this.loading = true
                var query = this.getQuery()
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            getQuery(extraParams) {
                var query = this.$db.Expense
                    .include('supplier', 'object')
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params(Object.assign({
                        query: this.search
                    }, extraParams))
                if(this.period instanceof Array && this.period.length === 2) {
                    query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
                }
                if(!this._.isNil(this.filterByVehicle)) query = query.where('object_id', this.filterByVehicle)
                return query
            },
            async createExport() {
                this.loading = true
                let query = this.getQuery({export: true})
                let base = query._fromResource || `${query.baseURL()}/${query.resource()}`
                base = query._customResource
                    ? `${query.baseURL()}/${query._customResource}`
                    : base
                let url = `${base}${query._builder.query()}`
                return window.axios.get(`${url}`, {
                    responseType: 'blob'
                }).then((response) => {
                    const contentDisposition = this._.get(response, 'headers.content-disposition')
                    const filename = contentDisposition.split("filename=")[1];
                    const downloadUrl = window.URL.createObjectURL(new Blob([response?.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', filename); //any other extension
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch((err) => {
                    console.error(err)
                }).finally(() => {
                    this.loading = false
                })
            },
        },
    };
</script>
